<template>
  <div>
    <!--Header-->
    <div class="header bg-success pt-5 pb-4">
      <b-container fluid>
        <div class="header-body">
          <b-row align-v="center" >
            <b-col lg="7 mt--2">
              <div class="pr-6">
                <h1 class="display-3 text-white font-weight-bold mb-0">Azure DevOps Integration Instant Syncing</h1>
                <h2 class="display-4 text-white font-weight-light">Zendesk, Freshdesk, Freshservice, monday Azure DevOps Integration provides Syncing of Data (Comments, Status and Attachments).</h2>
                <p class="text-white mt-4">Syncing of Comments, Status and Attachments from Azure DevOps to Zendesk, Freshdesk, Freshservice, monday</p>
                <p class="text-white mt-2">We are providing the few types of syncing of comments from Azure DevOps:-</p>
                <ol class="text-white">
                    <li>Syncing of all comments from Azure DevOps to (Zendesk,Freshdesk,Freshservice).</li>
                    <li>Syncing of tag based comments from Azure DevOps to (Zendesk,Freshdesk,Freshservice).</li>
                    <li>Posting comment to  (Zendesk,Freshdesk,Freshservice) as Public or Private tag based.</li>
                  </ol>
                  <p class="text-white">We are providing the few types of syncing of comments from Zendesk or Freshdesk or Freshservice:-</p>
                  <ol class="text-white">
                    <li>Syncing of all comments from Zendesk, Freshdesk, Freshservice, monday to Azure DevOps.</li>
                    <li>Syncing of tag based comments from Zendesk, Freshdesk, Freshservice, monday to Azure DevOps.</li>
                  </ol>
                <div class="mt-3 mb-3">
                  <router-link to="/apps/zendesk-azure-devops-integration" class="btn btn-neutral text-primary my-2">Zendesk Azure DevOps Integration</router-link>
                  <router-link to="/apps/freshdesk-azure-devops-integration" class="btn btn-neutral text-primary my-2">Freshdesk Azure DevOps Integration</router-link>
                  <router-link to="/apps/freshservice-azure-devops-integration" class="btn btn-neutral text-primary my-2">Freshservice Azure DevOps Integration</router-link>
                  <a href="mailto:support@devopsintegration.io" class="btn btn-neutral text-primary my-2">Purchase App Licence Now</a>
                </div>
                  <p class="text-white">
                    We also support customization based on customer request and tailored to your needs! We bring Azure DevOps closer to your business requirements!
                  </p>
                  <p class="text-white">
                    The Zendesk-Azure DevOps app provides couple of options like Create Work Item, Link Work Item, Notify, Work Item History & Configure App. 
                  </p>
              </div>
            </b-col>
            <b-col lg="5">
              <b-row class="pt-5">
                <b-col md="6">
                  <b-card no-body >
                    <b-card-body >
                      <div class="icon icon-shape bg-gradient-warning text-white rounded-circle shadow mb-4">
                        <i class="fa fa-info"></i>
                      </div>
                      <h5 class="h3">Create Work Item</h5>
                      <p>The Create Work Item lets the user to create new work item # in Azure DevOps from Zendesk, support agent can select type of work item he/she want to create like Bug, Epic, Feature, Task, User Story etc. Based on the work item type selection he will see all the Azure DevOps fields.</p>
                    </b-card-body>
                  </b-card>
                  <b-card no-body>
                    <b-card-body >
                      <div class="icon icon-shape bg-gradient-success text-white rounded-circle shadow mb-4">
                        <i class="fa fa-sync"></i>
                      </div>
                      <h5 class="h3">Bi-Directional Syncing</h5>
                      <p>In the Zendesk-Azure DevOps app Enable Syncing lets you enable the syncing of data from Zendesk to Azure DevOps and Azure DevOps to Zendesk.</p>
                    </b-card-body>
                  </b-card>
                </b-col>
                <b-col md="6" class="pt-lg-5 pt-4">
                  <b-card no-body>
                    <b-card-body class="mb-4">
                      <div class="icon icon-shape bg-gradient-red text-white rounded-circle shadow mb-4">
                        <i class="fa fa-server"></i>
                      </div>
                      <h5 class="h3">On-Premise and Cloud Support</h5>
                      <p>
                        Our integration supports both On-Premise and Cloud servers.
                        The Azure DevOps Integration supports all version of Azure DevOps and TFS (both Cloud and On-Premise) versions.
                        Please send an email to <a class="text-orange" href="mailto:support@devopsintegration.io" target="_blank">support@devopsintegration.io</a> for more details.
                      </p>
                    </b-card-body>
                  </b-card>
                  
                  <b-card no-body class="mb-4">
                    <b-card-body >
                      <div class="icon icon-shape bg-gradient-info text-white rounded-circle shadow mb-4">
                        <i class="fa fa-cog"></i>
                      </div>
                      <h5 class="h3">Configure App</h5>
                      <p>This will help to map certain fields between Zendesk and Azure DevOps.</p>
                    </b-card-body>
                  </b-card>
                  
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100" style="display:none">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <section class="py-2 pl-5 pr-5 pb-9 bg-default">
      <b-row class="justify-content-center text-left">
        <b-col md="12">
          <h2 class="display-3 text-white">Zendesk - Azure DevOps Integration</h2>
          <p class="lead text-white">
            Zendesk-Azure DevOps Integration App simple integration between Zendesk and Azure DevOps. Support agents using this app can Create, link, notify Azure DevOps work items. Zendesk - Azure DevOps integration app allows the agents to create Azure DevOps work items from Zendesk ticket very easily. Zendesk-Azure DevOps app also allows support agents to link existing Zendesk tickets to an existing Azure DevOps work items. In addition, Zendesk-Azure DevOps app allows support agents to help notify the Azure DevOps team, by sending comments from Zendesk support.
          </p>
          <p class="lead text-white">
            We also support customization based on customer request and tailored to your needs! We bring Azure DevOps closer to your business requirements!
          </p>
          <p class="lead text-center">
            <router-link to="/apps/zendesk-azure-devops-integration" class="btn btn-primary my-2">Explore More about this</router-link>
          </p>
        </b-col>
      </b-row>
    </section>
    <section class="section section-lg pt-lg-0 mt--7">
      <b-container>
        <b-row class="justify-content-center">
          <b-col lg="12" >
            <b-row >
              <b-col lg="4">
                <b-card no-body class="card-lift--hover shadow border-0">
                  <b-card-body class="py-5">
                    <div class="icon icon-shape bg-gradient-primary text-white rounded-circle mb-4">
                      <i class="ni ni-check-bold"></i>
                    </div>
                    <h4 class="h3 text-primary text-uppercase">Azure DevOps Integration</h4>
                    <p class="description mt-3">DevOpsIntegration.IO provides integration between several Customer Support portals and Azure DevOps portal. We provide integration between Zendesk - Azure DevOps, Freshdesk - Azure DevOps, Freshservice - Azure DevOps etc.</p>
                    <div>
                      <b-badge pill variant="primary">Zendesk</b-badge>
                      <b-badge pill variant="primary">Freshdesk</b-badge>
                      <b-badge pill variant="primary">Freshservice</b-badge>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col lg="4">
                <b-card no-body class="card-lift--hover shadow border-0">
                  <b-card-body  class="py-5">
                    <div class="icon icon-shape bg-gradient-success text-white rounded-circle mb-4">
                      <i class="ni ni-istanbul"></i>
                    </div>
                    <h4 class="h3 text-success text-uppercase">Customization Support</h4>
                    <p class="description mt-3">We also support customization based on customer request and tailored to your needs! We bring Azure DevOps closer to your business requirements!
                        <a href="mailto:support@devopsintegration.io" target="_blank">support@devopsintegration.io</a> Email us your requirements.</p>
                    <div>
                      <b-badge pill variant="success">SLA Support</b-badge>
                      <b-badge pill variant="success">Customizable</b-badge>
                      <b-badge pill variant="success">Simple to use</b-badge>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col lg="4">
                <b-card no-body class="card-lift--hover shadow border-0">
                  <b-card-body class="py-5">
                    <div class="icon icon-shape bg-gradient-warning text-white rounded-circle mb-4">
                      <i class="ni ni-planet"></i>
                    </div>
                    <h4 class="h3 text-warning text-uppercase">Full Sass support</h4>
                    <p class="description mt-3">
                      We provide 24*7 full support to our customers. Contact Us for any kind of support you need to integrate your Custom Support like Zendesk, Freshdesk, Freshservice, monday with Azure DevOps.
                    </p>
                    <div>
                      <b-badge pill variant="warning">Easy Integration</b-badge>
                      <b-badge pill variant="warning">Awesome Design</b-badge>
                      <b-badge pill variant="warning">Full Support</b-badge>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="py-2 pl-5 pr-5 pb-9 bg-default">
      <b-row class="justify-content-center text-left">
        <b-col md="12">
          <h2 class="display-3 text-white">Freshdesk - Azure DevOps Integration</h2>
          <p class="lead text-white">Our Best Integration Services Make You Feel Good</p>
          <p class="lead text-white">
            Freshdesk - Azure DevOps Integration App offers simple integration between Freshdesk and Azure DevOps. Using this app, support agents can create, link, and notify Azure DevOps work items. You can collaborate with your support team and developers in one place.
          </p>
          <p class="lead text-white">
            Freshdesk - Azure DevOps integration app allows the agents to create Azure DevOps work items from Freshdesk ticket very easily. The Freshdesk-Azure DevOps app also allows support agents to link existing Freshdesk tickets to existing Azure DevOps work items. In addition, the Freshdesk-Azure DevOps app allows support agents to help notify the Azure DevOps team by sending comments from Freshdesk support.
            Freshdesk - Azure DevOps Integration App offers simple integration between Freshdesk and Azure DevOps. Using this app, support agents can create, link, and notify Azure DevOps work items. You can collaborate with your support team and developers in one place.
          </p>
          <p class="lead text-white">
            We also support customization based on customer requests and tailored to your needs! We bring Azure DevOps closer to your business requirements!
          </p>
          <p class="lead text-center">
            <router-link to="/apps/freshdesk-azure-devops-integration" class="btn btn-primary my-2">Explore More about this</router-link>
          </p>
        </b-col>
      </b-row>
    </section>
    <section class="section section-lg pt-lg-0 mt--7">
      <b-container>
        <b-row class="justify-content-center">
          <b-col lg="12" >
            <b-row >
              <b-col lg="4">
                <b-card no-body class="card-lift--hover shadow border-0">
                  <b-card-body class="py-5">
                    <div class="icon icon-shape bg-gradient-primary text-white rounded-circle mb-4">
                      <i class="ni ni-check-bold"></i>
                    </div>
                    <h4 class="h3 text-primary text-uppercase">Fast Service</h4>
                    <p class="description mt-3">We are running on Microsoft Azure for faster processing.</p>
                    <div>
                      <b-badge pill variant="primary">Freshdesk Azure DevOps Integration</b-badge>
                      <b-badge pill variant="primary">Fast Response</b-badge>
                      <b-badge pill variant="primary">Instant Syncing</b-badge>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col lg="4">
                <b-card no-body class="card-lift--hover shadow border-0">
                  <b-card-body  class="py-5">
                    <div class="icon icon-shape bg-gradient-success text-white rounded-circle mb-4">
                      <i class="ni ni-istanbul"></i>
                    </div>
                    <h4 class="h3 text-success text-uppercase">Time Saving</h4>
                    <p class="description mt-3">Freshdesk - Azure DevOps app helps you save your time by quickly processing your data.</p>
                    <div>
                      <b-badge pill variant="success">Customize View</b-badge>
                      <b-badge pill variant="success">Auto Fill Fields</b-badge>
                      <b-badge pill variant="success">Auto Creation</b-badge>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col lg="4">
                <b-card no-body class="card-lift--hover shadow border-0">
                  <b-card-body class="py-5">
                    <div class="icon icon-shape bg-gradient-warning text-white rounded-circle mb-4">
                      <i class="ni ni-planet"></i>
                    </div>
                    <h4 class="h3 text-warning text-uppercase">Business Planning</h4>
                    <p class="description mt-3">We can customize the Azure DevOps integration based on your Business modal.</p>
                    <div>
                      <b-badge pill variant="warning">Customize Mapping</b-badge>
                      <b-badge pill variant="warning">Fields Syncing</b-badge>
                      <b-badge pill variant="warning">Mapping of Fields</b-badge>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section class="py-2 pl-5 pr-5 pb-9 bg-default">
      <b-row class="justify-content-center text-left">
        <b-col md="12">
          <h2 class="display-3 text-white">Freshservice - Azure DevOps Integration</h2>
          <p class="lead text-white">
            Freshservice-Azure DevOps Integration App simple integration between Freshservice and Azure DevOps. Support agents using this app can Create, link, notify Azure DevOps work items. You can Collaborate your support team and developers at one place. \n\n Zendesk-Azure DevOps app allows the support agents to create Azure DevOps work items from Freshservice apps form. Freshservice-Azure DevOps app also allows support agents to link existing Zendesk tickets to an existing Azure DevOps work items. In addition, Freshservice-Azure DevOps app allows support agents to help notify the Azure DevOps team, by sending comments from Freshservice support.
          </p>
          <p class="lead text-white">
            We provides integration between several Customer Support portals and Azure DevOps portal. We provide integration between Zendesk - Azure DevOps, Freshdesk - Azure DevOps, Freshservice - Azure DevOps etc.
            Azure DevOps integrates your work items. Create bugs, features, or custom work items. Use area paths, iteration, priority, severity.
            Azure DevOps integrates your work items and your own custom fields. link existing bugs, features, or custom work items. Notify workitems.
          </p>
          <p class="lead text-white">
            Azure DevOps integration allows you to sync your comments, status, system fields and custom fields in both directions based on your needs.
            We also support customization based on customer requests and tailored to your needs! We bring Azure DevOps closer to your business requirements!
          </p>
          <p class="lead text-center">
            <router-link to="/apps/freshservice-azure-devops-integration" class="btn btn-primary my-2">Explore More about this</router-link>
          </p>
        </b-col>
      </b-row>
    </section>
    <section class="section section-lg pt-lg-0 mt--7">
      <b-container>
        <b-row class="justify-content-center">
          <b-col lg="12" >
            <b-row >
              <b-col lg="4">
                <b-card no-body class="card-lift--hover shadow border-0">
                  <b-card-body class="py-5">
                    <div class="icon icon-shape bg-gradient-primary text-white rounded-circle mb-4">
                      <i class="ni ni-check-bold"></i>
                    </div>
                    <h4 class="h3 text-primary text-uppercase">Azure DevOps Integration</h4>
                    <p class="description mt-3">DevOpsIntegration.IO provides integration between several Customer Support portals and Azure DevOps portal. We provide integration between Zendesk - Azure DevOps, Freshdesk - Azure DevOps, Freshservice - Azure DevOps etc.</p>
                    <div>
                      <b-badge pill variant="success">File Uploads</b-badge>
                      <b-badge pill variant="success">Files Syncing</b-badge>
                      <b-badge pill variant="success">Status Syncing</b-badge>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col lg="4">
                <b-card no-body class="card-lift--hover shadow border-0">
                  <b-card-body  class="py-5">
                    <div class="icon icon-shape bg-gradient-success text-white rounded-circle mb-4">
                      <i class="ni ni-istanbul"></i>
                    </div>
                    <h4 class="h3 text-success text-uppercase">Experienced Team</h4>
                    <p class="description mt-3">
                      We have experienced team who can help you to meet your requirements.
                      Please send an email to <a class="text-orange" href="mailto:support@devopsintegration.io" target="_blank">support@devopsintegration.io</a> for your
                      requirements and they will help you.

                    </p>
                    <div>
                      <b-badge pill variant="primary">Complete Documentation</b-badge>
                      <b-badge pill variant="primary">Active Sync</b-badge>
                      <b-badge pill variant="primary">Unlimited WorkItems</b-badge>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col lg="4">
                <b-card no-body class="card-lift--hover shadow border-0">
                  <b-card-body class="py-5">
                    <div class="icon icon-shape bg-gradient-warning text-white rounded-circle mb-4">
                      <i class="ni ni-planet"></i>
                    </div>
                    <h4 class="h3 text-warning text-uppercase">Full Sass support</h4>
                    <p class="description mt-3">
                      We provide 24*7 full support to our customers. Contact Us for any kind of support you need to integrate your Custom Support like Zendesk, Freshdesk, Freshservice, monday with Azure DevOps.
                    </p>
                    <div>
                      <b-badge pill variant="warning">Easy Integration</b-badge>
                      <b-badge pill variant="warning">Awesome Design</b-badge>
                      <b-badge pill variant="warning">Full Support</b-badge>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="py-6" style="display:none">
      <b-container>
        <b-row align-v="center" class="row-grid">
          <b-col md="6" class="order-md-2">
            <b-img src="img/theme/landing-1.png" fluid />
          </b-col>
          <b-col md="6" class="order-md-1">
            <div class="pr-md-5">
              <h1>Awesome features</h1>
              <p>This dashboard comes with super cool features that are meant to help in the process. Handcrafted components, page examples and functional widgets are just a few things you will see and love at first sight.</p>
              <ul class="list-unstyled mt-5">
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <div>
                      <b-badge pill variant="success" class="badge-circle mr-3">
                        <i class="ni ni-settings-gear-65"></i>
                      </b-badge>
                    </div>
                    <div>
                      <h4 class="mb-0">Carefully crafted components</h4>
                    </div>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <div>
                      <b-badge pill variant="success" class="badge-circle mr-3">
                        <i class="ni ni-html5"></i>
                      </b-badge>
                    </div>
                    <div>
                      <h4 class="mb-0">Amazing page examples</h4>
                    </div>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <div>
                      <b-badge pill variant="success" class="badge-circle mr-3">
                        <i class="ni ni-satisfied"></i>
                      </b-badge>
                    </div>
                    <div>
                      <h4 class="mb-0">Super friendly support team</h4>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="py-6" style="display:none">
      <b-container>
        <b-row align-v="center" class="row-grid">
          <b-col md="6">
            <b-img src="img/theme/landing-2.png" fluid />
          </b-col>
          <b-col md="6">
            <div class="pr-md-5">
              <h1>Example pages</h1>
              <p>If you want to get inspiration or just show something directly to your clients, you can jump start your development with our pre-built example pages.</p>
              <router-link to="/contact" class="font-weight-bold text-warning mt-5">Explore pages</router-link>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="py-6" style="display:none">
      <b-container>
        <b-row align-v="center" class="row-grid">
          <b-col md="6" class="order-md-2">
            <b-img src="img/theme/landing-3.png" fluid />
          </b-col>
          <b-col md="6" class="col-md-6">
            <div class="pr-md-5">
              <h1>Lovable widgets and cards</h1>
              <p>We love cards and everybody on the web seems to. We have gone above and beyond with options for you to organise your information. From cards designed for content, to pricing cards or user profiles, you will have many options to choose from.</p>
              <router-link to="/widgets" class="font-weight-bold text-info mt-5">Explore widgets</router-link>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="py-7 section-nucleo-icons bg-white overflow-hidden" style="display:none">
      <b-container>
        <b-row class="justify-content-center">
          <b-col lg="8" class="text-center">
            <h2 class="display-3">Nucleo Icons</h2>
            <p class="lead">
              The official package contains over 21.000 icons which are looking great in combination with Argon Design System. Make sure you check all of them and use those that you like the most.
            </p>
            <div class="btn-wrapper">
              <a href="https://www.creative-tim.com/learning-lab/bootstrap-vue/icons/argon-dashboard" class="btn btn-primary">View demo icons</a>
              <a href="https://nucleoapp.com/?ref=1712" target="_blank" class="btn btn-default mt-3 mt-md-0">View all icons</a>
            </div>
          </b-col>
        </b-row>
        <div class="blur--hover">
          <a href="https://www.creative-tim.com/learning-lab/bootstrap-vue/icons/argon-dashboard">
            <div class="icons-container blur-item mt-5">
              <!-- Center -->
              <i class="icon ni ni-diamond"></i>
              <!-- Right 1 -->
              <i class="icon icon-sm ni ni-album-2"></i>
              <i class="icon icon-sm ni ni-app"></i>
              <i class="icon icon-sm ni ni-atom"></i>
              <!-- Right 2 -->
              <i class="icon ni ni-bag-17"></i>
              <i class="icon ni ni-bell-55"></i>
              <i class="icon ni ni-credit-card"></i>
              <!-- Left 1 -->
              <i class="icon icon-sm ni ni-briefcase-24"></i>
              <i class="icon icon-sm ni ni-building"></i>
              <i class="icon icon-sm ni ni-button-play"></i>
              <!-- Left 2 -->
              <i class="icon ni ni-calendar-grid-58"></i>
              <i class="icon ni ni-camera-compact"></i>
              <i class="icon ni ni-chart-bar-32"></i>
            </div>
            <span class="blur-hidden h5 text-success">Eplore all the 21.000+ Nucleo Icons</span>
          </a>
        </div>
      </b-container>
    </section>
    <section class="py-7" style="display:none">
      <b-container>
        <b-row class="row-grid justify-content-center">
          <b-col lg="8" class="text-center">
            <h2 class="display-3">Do you love this awesome <span class="text-success">Dashboard for BootstrapVue ?</span></h2>
            <p class="lead">Cause if you do, it can be yours now. Hit the button below to navigate to get the free version or purchase a license for your next project. Build a new web app or give an old BootstrapVue project a new look!</p>
            <div class="btn-wrapper">
              <base-button type="neutral" disabled href="javascript:void(0)" aria-pressed="true" target="_blank"><span class="btn-inner--text">Get FREE version</span></base-button>
              <a href="https://www.creative-tim.com/product/bootstrap-vue-argon-dashboard-pro?ref=bvadp-index-page" class="btn btn-success btn-icon mb-3 mb-sm-0">
                <span class="btn-inner--icon"><i class="ni ni-basket"></i></span>
                <span class="btn-inner--text">Purchase now</span>
                <b-badge size="md" pill variant="danger" class="badge-floating border-white">$89</b-badge>
              </a>
            </div>
            <div class="text-center">
              <h4 class="display-4 mb-5 mt-5">Available on these technologies</h4>
              <b-row class="justify-content-center">
                <b-col md="2" cols="3" class="my-2">
                  <el-tooltip placement="top" content="Bootstrap 4 - Most popular front-end component library">
                    <a href="https://www.creative-tim.com/product/argon-dashboard-pro?ref=bvadp-index-page" target="_blank">
                      <b-img src="https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/bootstrap.jpg" fluid rounded="circle" class="shadow shadow-lg--hover" />
                    </a>
                  </el-tooltip>
                </b-col>
                <b-col md="2" cols="3" class="my-2">
                  <el-tooltip placement="top" content="BootstrapVue - Most popular front-end component library for Vue.js">
                    <a href="https://www.creative-tim.com/product/bootstrap-vue-argon-dashboard-pro?ref=vadp-index-page" target="_blank">
                      <b-img src="https://test.creative-tim.com/assets/icon-bootstrap-vue-f224def7158bbb9ed0e8436fd745d8cf6002ff00f3f65184282c4258958e598c.jpg" fluid rounded="circle" class="shadow shadow-lg--hover" />
                    </a>
                  </el-tooltip>
                </b-col>
                <b-col md="2" cols="3" class="my-2">
                  <el-tooltip placement="top" content="Vue.js - The progressive javascript framework">
                    <a href="https://www.creative-tim.com/product/vue-argon-dashboard-pro?ref=bvadp-index-page" target="_blank">
                      <b-img src="https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/vue.jpg" fluid rounded="circle" />
                    </a>
                  </el-tooltip>
                </b-col>
                <b-col md="2" cols="3" class="my-2">
                  <el-tooltip placement="top" content="Sketch - Digital design toolkit">
                    <a href="https://www.sketchapp.com/" rel="noffolow"  target="_blank">
                      <b-img src="https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/sketch.jpg" fluid rounded="circle" />
                    </a>
                  </el-tooltip>
                </b-col>
                <b-col md="2" cols="3" class="my-2">
                  <el-tooltip placement="top" content="[Coming Soon] Adobe Photoshop - Software for digital images manipulation">
                    <a href="https://www.adobe.com/products/photoshop.html" rel="noffolow" target="_blank">
                      <b-img src="https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/ps.jpg" fluid rounded="circle" class="opacity-3" />
                    </a>
                  </el-tooltip>
                </b-col>
                <b-col md="2" cols="3" class="my-2">
                  <el-tooltip placement="top" content="Angular - One framework. Mobile ">
                    <a href="https://www.creative-tim.com/product/argon-dashboard-pro-angular?ref=bvadp-index-page" target="_blank">
                      <b-img src="https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/angular.jpg" fluid rounded="circle" />
                    </a>
                  </el-tooltip>
                </b-col>
                <b-col md="2" cols="3" class="my-2">
                  <el-tooltip placement="top" content="React - A JavaScript library for building user interfaces">
                    <a href="https://www.creative-tim.com/product/argon-dashboard-pro-react?ref=bvadp-index-page" target="_blank">
                      <b-img src="https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/react.jpg" fluid rounded="circle" />
                    </a>
                  </el-tooltip>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>
<script>
  import { Tooltip } from 'element-ui'
  export default {
    name: 'features-page',
    components: {
      [Tooltip.name]: Tooltip
    },
    data () {
      return {
        appType:null
      }
    },
    created(){
      this.init();
    },
    watch: {
      appType(val) {
        this.init();
      }
    },
    methods:{
      init(){
        let appType=this.$route.params.appType;
        if(!appType) return;
        this.appType=appType;
        let redirectUrl;
        switch(this.appType){
          case 'zendesk-devops':
            redirectUrl='https://support.devopsintegration.io/support/solutions/folders/82000310004';
          break;
          case 'freshdesk-devops':
            redirectUrl='https://support.devopsintegration.io/support/solutions/folders/82000286266';
          break;
          case 'freshservice-devops':
            redirectUrl='https://support.devopsintegration.io/support/solutions/folders/82000339153';
          break;
          case 'monday-devops':
            redirectUrl='https://support.devopsintegration.io/support/solutions/folders/82000697946';
          break;
          case 'zendesk-github':
            redirectUrl = 'https://support.devopsintegration.io/support/solutions/folders/82000444589';
          break;
          case 'freshdesk-github':
            redirectUrl = 'https://support.devopsintegration.io/support/solutions/folders/82000444588';
          break;
          case 'freshservice-github':
            redirectUrl = 'https://support.devopsintegration.io/support/solutions/folders/82000444590';
          break;
        }
        window.location.replace(redirectUrl);
      }
    }
  };
</script>
